import { useState } from 'react';

const BASE_URL = 'https://trading.godev.it'; // Cambia con il tuo dominio

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function handleLogin() {
    try {
      const response = await fetch(`${BASE_URL}/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `username=${username}&password=${password}`
      });
      const result = await response.json();
      if (result.success) {
        onLoginSuccess();
      } else {
        setError('Credenziali errate');
      }
    } catch (err) {
      setError('Errore connessione');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white p-8">
      <div className="bg-gray-800 p-8 rounded">
        <h2 className="text-3xl font-bold mb-4">Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="mb-4 px-4 py-2 rounded text-black w-full"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4 px-4 py-2 rounded text-black w-full"
        />
        <button onClick={handleLogin} className="px-4 py-2 bg-blue-500 rounded hover:bg-blue-600 w-full">Login</button>
        {error && <p className="mt-4 text-red-400">{error}</p>}
      </div>
    </div>
  );
}